import { tryToFocus } from "./tryToFocus.js";

/**
 *
 *
 *
 *
 */
export const focusDeepWithin = (element: HTMLElement): boolean => {
  return (
    element instanceof HTMLSlotElement
      ? element.assignedElements()
      : Array.from((element.shadowRoot ?? element).children)
  )
    .filter((ele) => ele instanceof HTMLElement)
    .some((ele) => tryToFocus(ele) || focusDeepWithin(ele));
};
